import axios from 'axios'
import { message } from 'antd';
import React from 'react';
import config from './config';
import { store } from '@/redux/store';
import { httpRequestList } from '@hooks/clearHttpRequest';
import { logOut } from '@/redux/authentication/actionCreator';
import { checkHasRouter } from './utils'
import Cookies from 'js-cookie'

const { CancelToken } = axios;

/**
 * @description: 读取Token
 * @parameter {*}
 * @author: Mingzhen
 * @return {String}
 */
const getToken = () => {
    let token = Cookies.get(process.env.REACT_APP_TOKEN_KEY, { domain: process.env.REACT_APP_DOMAIN }) || ''
    return token
}


class checkErrorMessageClass {
    // 初始化队列
    constructor() {
        this.queue = []; // 队列
        this.timeout = 5000; // 清除时间 ms
        this.currentPathName = '';
    }
    // 在队列中查找是否存在对应key
    searchErrorCode(key) {
        return this.queue.includes(key);
    }
    // 新的message
    addMessage(errorCode) {
        // 如果该errorCode不在队列中则处理
        const pathname = document.location.pathname;
        if (pathname !== this.currentPathName) {
            this.clearQueue();
            this.currentPathName = pathname;
        }
        if (!this.searchErrorCode(errorCode)) {
            let desc = errorCode;
            if (typeof errorCode === 'number') {
                desc = React.t("ErrorCode." + errorCode)
            }

            message.error(desc);
            this.queue.push(errorCode);
            // 5s后清除该条数据
            setTimeout(() => {
                this.removeFirstMessage()
            }, this.timeout);
        }
    }
    removeFirstMessage() {
        this.queue.length && this.queue.shift();
    }
    clearQueue() {
        this.queue = [];
    }
}
const checkErrorMessage = new checkErrorMessageClass();

function Index({ ...config }) {
    const dispatch = store.dispatch;
    const cancelToken = new CancelToken((c) => {
        httpRequestList.push(c)
    })
    const service = axios.create({
        // 默认headers
        /*headers: {
          'Cache-Control': 'no-cache'
        },*/
        baseURL: config.adminPannelURL, // 未指定使用默认
        // withCredentials: true, // 携带cookies
        timeout: 30000, // request timeout
        cancelToken,
    })

    // request interceptor
    service.interceptors.request.use(
        config => {
            return config
        },
        error => {
            return Promise.reject(error)
        }
    )

    // response interceptor
    service.interceptors.response.use(
        response => {
            return response
        },
        error => {
            const { request = {} } = error;
            const { status, response } = request;
            error.status = status
            try {
                error.res = JSON.parse(response)
            } catch (e) {
                console.warn(e)
            }
            return Promise.reject(error)
        }
    )

    /**
     * @description: 发起请求
     * @author: Mingzhen
     * @parameter method 请求方法
     * @parameter url 请求地址
     * @parameter params 要发送的数据
     * @parameter config 配置
     * @parameter axiosConfig Axios配置项
     * @return {Promise<never>|Promise<AxiosResponse<T>>}
     */
    const requestProcessor = (method, url, params = {}, headers, config, axiosConfig) => {
        // 鉴权
        const token = getToken()
        if (token) {
            headers['Authorization'] = token;
        }
        // 表单序列化
        if (config.formData) {
            const fd = new FormData();
            for (let key in params) {
                fd.append(key, params[key])
            }
            params = fd
        }

        // 根据请求类型发起请求
        switch (method.toUpperCase()) {
            case 'GET':
                return service.get(url, {
                    params,
                    headers,
                    ...axiosConfig,
                })
            case 'POST':
                return service.post(url, params, {
                    headers,
                    ...axiosConfig,
                })
            case 'DELETE':
                return service.delete(url, {
                    params,
                    headers,
                    ...axiosConfig,
                })
            case 'PUT':
                return service.put(url, params, {
                    headers,
                    ...axiosConfig,
                })
            default:
                return Promise.reject(new Error(`${method} 方法无效，请用正确的请求方法`))
        }
    }

    this.request2 = async ({ method, url, params, headers = {}, config = {}, axiosConfig = {} }) => {
        const { isToast = true } = config

        try {
            const response = await requestProcessor(method, url, params, headers, config, axiosConfig);
            // 此处可以再次拦截
            if (axiosConfig?.pass) return response.data;
            let { status, errorCode,message } = response.data;
            if (status !== 0&&status!=="success") {
                if (errorCode === 11002) errorCode = 10401;
                if (errorCode === 10401||status==="expired") {
                    // invalid token need to login
                    dispatch(logOut());
                }
                const desc = React.t("ErrorCode." + errorCode);
                const errorUserCode = [10305, 10101]
                if (errorUserCode.includes(errorCode)) {
                    let { pathname, search } = window.location;
                    pathname = pathname.split('/');
                    let nfind = false;
                    while (!nfind && pathname.length > 1) {
                        pathname.pop();
                        nfind = checkHasRouter(pathname.join('/'));
                    }
                    isToast && message.error(desc);
                    window.location.href = pathname.join('/');
                    return Promise.reject();
                }
                isToast && checkErrorMessage.addMessage(errorCode||message);
                return Promise.reject();
            }
            return response.data
        } catch (error) {
            if (error?.status === 401) {
                dispatch(logOut());
                checkErrorMessage.addMessage(10401);
            } else {
                isToast && checkErrorMessage.addMessage(error.message)
            }

            throw error
        } finally {
        }

    }
}

export { config, getToken }
export const { request2 } = new Index(config)
export default Index